import { render, staticRenderFns } from "./chips-container.vue?vue&type=template&id=2644ce13&"
import script from "./chips-container.vue?vue&type=script&lang=js&"
export * from "./chips-container.vue?vue&type=script&lang=js&"
import style0 from "./chips-container.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/user/projects/zp-front-up/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2644ce13')) {
      api.createRecord('2644ce13', component.options)
    } else {
      api.reload('2644ce13', component.options)
    }
    module.hot.accept("./chips-container.vue?vue&type=template&id=2644ce13&", function () {
      api.rerender('2644ce13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chips/chips-container.vue"
export default component.exports